/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A summary of the toolset backing a hosted MCP server.
 */
export type McpServerToolsetSummary = {
  /**
   * The toolset's description, if any
   */
  description?: string | undefined;
  /**
   * Whether every configured tool is an external MCP proxy tool, so the real tool count is unknown until a user signs in
   */
  externalMcpProxyOnly: boolean;
  /**
   * The distinct slugs of the external MCP sources the toolset's configured tools come from, sorted
   */
  externalMcpSlugs: Array<string>;
  /**
   * The ID of the external OAuth server attached to the toolset, if any
   */
  externalOauthServerId?: string | undefined;
  /**
   * The ID of the toolset
   */
  id: string;
  /**
   * The name of the toolset
   */
  name: string;
  /**
   * The registry specifier the toolset originated from, if any
   */
  registrySpecifier?: string | undefined;
  /**
   * The slug of the toolset
   */
  slug: string;
  /**
   * The number of distinct configured tools in the latest toolset version, excluding external MCP proxy tools. Counts configured tool URNs, so it may differ from the number of tools that resolve against the active deployment.
   */
  toolCount: number;
  /**
   * The toolset's tool selection mode
   */
  toolSelectionMode: string;
};

/** @internal */
export const McpServerToolsetSummary$inboundSchema: z.ZodMiniType<
  McpServerToolsetSummary,
  unknown
> = z.pipe(
  z.object({
    description: z.optional(z.string()),
    external_mcp_proxy_only: z.boolean(),
    external_mcp_slugs: z.array(z.string()),
    external_oauth_server_id: z.optional(z.string()),
    id: z.string(),
    name: z.string(),
    registry_specifier: z.optional(z.string()),
    slug: z.string(),
    tool_count: z.int(),
    tool_selection_mode: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "external_mcp_proxy_only": "externalMcpProxyOnly",
      "external_mcp_slugs": "externalMcpSlugs",
      "external_oauth_server_id": "externalOauthServerId",
      "registry_specifier": "registrySpecifier",
      "tool_count": "toolCount",
      "tool_selection_mode": "toolSelectionMode",
    });
  }),
);

export function mcpServerToolsetSummaryFromJSON(
  jsonString: string,
): SafeParseResult<McpServerToolsetSummary, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => McpServerToolsetSummary$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'McpServerToolsetSummary' from JSON`,
  );
}
